import React from 'react';
import _ from 'lodash';
import * as util from '#packages/util';
import { getEditorHost, isResponsiveEditor } from '@wix/santa-editor-utils';
import experiment from 'experiment';
import {
  mapDispatchToProps,
  mapStateToProps,
  type WixAppsCollectionsListDispatchProps,
  type WixAppsCollectionsListStateProps,
  type WixAppsCollectionsListOwnProps,
} from './wixAppsCollectionsList.mapper';
import CollectionsList from '../collectionsList/collectionsList';
import { useRedirectToUserCollectionsTab } from '../../hooks/useRedirectToUserCollectionsTab';
import { CollectionsGroup } from '../utils/collections-group';
import { WixAppsCollectionsEmptyState } from './WixAppsCollectionsEmptyState';

interface WixAppsCollectionsListProps
  extends WixAppsCollectionsListOwnProps,
    WixAppsCollectionsListDispatchProps,
    WixAppsCollectionsListStateProps {}

const WixAppsCollectionsList: React.FC<WixAppsCollectionsListProps> = ({
  collections,
  selectTabByName,
  openContentManagerAdvancedSettings,
}) => {
  const showWixAppsEmptyState = experiment.isOpen(
    'specs.wixCode.ShowDisabledWixAppCollections',
  );

  useRedirectToUserCollectionsTab({
    collections,
    selectTabByName,
    redirectEnabled: !showWixAppsEmptyState,
  });

  const { title, subtitle } = _.cond([
    [
      () => getEditorHost() === 'BLOCKS',
      () => ({
        title: undefined,
        subtitle: 'blocks_wix_apps_collections_section_title',
      }),
    ],
    [
      isResponsiveEditor,
      () => ({
        title: undefined,
        subtitle:
          'EDITORX_CONTENT_MANAGER_6_BUTTON_WIX_APPS_COLLECTIONS_SUBTITLE_WITH_TITLE',
      }),
    ],
    [
      _.stubTrue,
      () => ({
        title: 'CONTENT_MANAGER_6_BUTTON_WIX_APPS_COLLECTIONS_TITLE',
        subtitle: 'CONTENT_MANAGER_6_BUTTON_WIX_APPS_COLLECTIONS_SUBTITLE',
      }),
    ],
  ])();

  if (collections.length === 0 && showWixAppsEmptyState) {
    return (
      <WixAppsCollectionsEmptyState
        openContentManagerAdvancedSettings={openContentManagerAdvancedSettings}
      />
    );
  }

  return (
    <CollectionsList
      collections={collections}
      title={title}
      subtitle={subtitle}
      showActionButtons={false}
      showVideoTooltip={false}
      selectTabByName={selectTabByName}
      collectionsGroup={CollectionsGroup.APPS}
    />
  );
};

export default util.hoc.connect(
  util.hoc.STORES.EDITOR_API,
  mapStateToProps,
  mapDispatchToProps,
)(WixAppsCollectionsList);
